import { useState } from "react";
import { post } from "../networking/RequestService";

/**
 * LinkedIn profilinden gelen önerileri kullanarak profil bilgilerini güncellemek için kullanılan hook
 * @returns {Object} - Hook fonksiyonları ve state'leri
 */
const useUpdateProfilFromSuggestions = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    const updateProfilFromSuggestions = async (params) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "updateProfilFromSuggestions",
                id: params.id,
                isManual: params.isManual || 0,
                linkedin_profile_id: params.linkedin_profile_id || "",
                url: params.url || "",
                resim: params.resim || "",
                headline: params.headline || "",
            };

            const response = await post(payload);

            if (response && response.data) {
                setData(response.data);
                return response.data;
            }

            return null;
        } catch (err) {
            setError(err);
            return null;
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        data,
        updateProfilFromSuggestions,
    };
};

export default useUpdateProfilFromSuggestions;
